export default __webpack_public_path__ + "static/media/default.8ee55c5028a1eb15eb1124952642e4b1.png";